import { useEffect } from 'react'
import Swal from 'sweetalert2'

const SweetAlertTwo = (props) => {

    const activeAlert = () => {
        Swal.fire({
            title: props.title,
            text: props.text,
            icon: props.icon,
            showCancelButton: props.showCancelButton,
            confirmButtonColor: props.confirmButtonColor,
            cancelButtonColor: props.cancelButtonColor,
            confirmButtonText: props.confirmButtonText
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: props.confirmTitle,
                    text: props.confirmText,
                    icon: props.confirmIcon,
                    showConfirmButton: false
                })
                props.handlePerform(Swal)
            } else {
                props.onCancel()
            }
        })
    }

    useEffect(() => {
        if (props.show) {
            activeAlert()
        }
    }, [props.show])
}

export default SweetAlertTwo